import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';

interface MetricCardProps {
  title: string;
  value: string;
  change?: {
    value: number;
    isPositive: boolean;
  };
  icon: React.ComponentType<{ className?: string }>;
  timeRange: string;
}

export function MetricCard({ title, value, change, icon: Icon, timeRange }: MetricCardProps) {
  return (
    <div className="bg-gray-800 rounded-lg p-6 relative overflow-hidden group hover:bg-gray-750 transition-colors">
      <div className="absolute top-0 right-0 mt-2 mr-2 text-xs text-gray-500">
        {timeRange.toUpperCase()}
      </div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-gray-400 text-sm font-medium">{title}</h3>
        <Icon className="h-6 w-6 text-red-500" />
      </div>
      <div className="flex flex-col space-y-2">
        <p className="text-2xl font-semibold text-white mb-1">{value}</p>
        {change && (
          <div className={clsx(
            'flex items-center text-sm self-start px-2 py-0.5 rounded-full transition-colors',
            'bg-opacity-10 group-hover:bg-opacity-20',
            change.isPositive ? 'bg-green-500' : 'bg-red-500',
            change.isPositive ? 'text-green-500' : 'text-red-500'
          )}>
            {change.isPositive ? (
              <ArrowUpIcon className="h-4 w-4 mr-1" />
            ) : (
              <ArrowDownIcon className="h-4 w-4 mr-1" />
            )}
            {Math.abs(change.value)}%
          </div>
        )}
      </div>
    </div>
  );
}